export default "__VITE_ASSET__CMkNVrxG__"